export enum soundAssetConfig {
    // BASE_LOOP = "assets/sounds/LK_BASEGAME_LOOP_1.m4a",
    // REEL_START = "assets/sounds/LK_REEL_START.m4a",
    // MEGA_WIN = "assets/sounds/LK_MEGA_WIN_STEP.m4a"
}